<footer class="footer">
  <div class="row align-items-center justify-content-xl-between">
    <div class="col-xl-6 mx-auto">
      <div class="copyright text-center text-muted">
        Tem Cashback &copy; {{ test | date : "yyyy" }} - Todos os direitos
        reservados.
      </div>
    </div>
  </div>
</footer>
